import React from 'react';
import { Loader } from 'lucide-react';

const MobileLoadingSpinner = ({ message = "Loading...", size = "large" }) => {
  const sizeClasses = {
    small: "w-4 h-4",
    medium: "w-8 h-8", 
    large: "w-12 h-12"
  };

  return (
    <div className="flex flex-col items-center justify-center p-8 text-center">
      <div className="relative">
        <Loader 
          className={`${sizeClasses[size]} text-blue-600 animate-spin`}
        />
      </div>
      <p className="mt-4 text-gray-600 text-sm">{message}</p>
    </div>
  );
};

export default MobileLoadingSpinner;